import { render, staticRenderFns } from "./ReviewDialog.vue?vue&type=template&id=25c2831b&scoped=true"
import script from "./ReviewDialog.vue?vue&type=script&lang=js"
export * from "./ReviewDialog.vue?vue&type=script&lang=js"
import style0 from "./ReviewDialog.vue?vue&type=style&index=0&id=25c2831b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c2831b",
  null
  
)

export default component.exports